/**
 * StatTable — a plain, scrollable stats table (Press Box season page and the
 * public stats page). 2026-10-17. `cols`: [{ key, label, left?, bold?, title?, render? }].
 */
export function StatTable({ cols, rows, empty = 'Nothing yet.' }) {
  const cell = { padding: '6px 8px', fontVariantNumeric: 'tabular-nums', textAlign: 'right', whiteSpace: 'nowrap' };
  return (
    <div style={{ overflowX: 'auto' }}>
      <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
        <thead>
          <tr>{cols.map(c => <th key={c.key} style={{ ...cell, textAlign: c.left ? 'left' : 'right', fontSize: 11, color: 'var(--text-2)', textTransform: 'uppercase', letterSpacing: '0.04em', borderBottom: '1px solid var(--border)' }} title={c.title || ''}>{c.label}</th>)}</tr>
        </thead>
        <tbody>
          {rows.length === 0 && <tr><td colSpan={cols.length} style={{ ...cell, textAlign: 'center', color: 'var(--text-3)' }}>{empty}</td></tr>}
          {rows.map((r, i) => (
            <tr key={r.userId || r.label + i} style={{ borderBottom: '1px solid var(--border)' }}>
              {cols.map(c => <td key={c.key} style={{ ...cell, textAlign: c.left ? 'left' : 'right', fontWeight: c.bold ? 700 : 400 }}>{c.render ? c.render(r) : (r[c.key] ?? '')}</td>)}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

const posTip = { F: 'Forward', D: 'Defense', G: 'Goalie' };
const labelWithPos = (r) => (<>{r.label}{r.pos ? <span style={{ color: 'var(--text-3)', fontWeight: 500, marginLeft: 6, fontSize: '0.85em' }} title={posTip[r.pos] || r.pos}>{r.pos}</span> : null}</>);
export const SKATER_COLS = [
  { key: 'label', label: 'Player', left: true, bold: true, render: labelWithPos },
  { key: 'gp', label: 'GP', title: 'Games played' },
  { key: 'g', label: 'G', title: 'Goals' },
  { key: 'a', label: 'A', title: 'Assists' },
  { key: 'p', label: 'P', title: 'Points', bold: true },
  { key: 'sog', label: 'SOG', title: 'Shots on goal' },
  { key: 'pim', label: 'PIM', title: 'Penalty minutes' },
];
export const GOALIE_COLS = [
  { key: 'label', label: 'Goalie', left: true, bold: true, render: labelWithPos },
  { key: 'gp', label: 'GP' },
  { key: 'sv', label: 'SV', title: 'Saves' },
  { key: 'ga', label: 'GA', title: 'Goals against' },
  { key: 'svPct', label: 'SV%', render: (r) => (r.svPct == null ? '–' : r.svPct.toFixed(3).replace(/^0/, '')) },
];
